/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addOrder } from '../fn/order-bill/add-order';
import { AddOrder$Params } from '../fn/order-bill/add-order';
import { addOrderBillDiscount } from '../fn/order-bill/add-order-bill-discount';
import { AddOrderBillDiscount$Params } from '../fn/order-bill/add-order-bill-discount';
import { deleteOrderBill } from '../fn/order-bill/delete-order-bill';
import { DeleteOrderBill$Params } from '../fn/order-bill/delete-order-bill';
import { deleteOrderBillItem } from '../fn/order-bill/delete-order-bill-item';
import { DeleteOrderBillItem$Params } from '../fn/order-bill/delete-order-bill-item';
import { listNotPrintedOrderBills } from '../fn/order-bill/list-not-printed-order-bills';
import { ListNotPrintedOrderBills$Params } from '../fn/order-bill/list-not-printed-order-bills';
import { listNotPrintedTrmOrderBills } from '../fn/order-bill/list-not-printed-trm-order-bills';
import { ListNotPrintedTrmOrderBills$Params } from '../fn/order-bill/list-not-printed-trm-order-bills';
import { listOrderBills } from '../fn/order-bill/list-order-bills';
import { listOrderBills_1 } from '../fn/order-bill/list-order-bills-1';
import { ListOrderBills_1$Params } from '../fn/order-bill/list-order-bills-1';
import { ListOrderBills$Params } from '../fn/order-bill/list-order-bills';
import { listOrderBillsForTable } from '../fn/order-bill/list-order-bills-for-table';
import { ListOrderBillsForTable$Params } from '../fn/order-bill/list-order-bills-for-table';
import { listOrderBillsSimple } from '../fn/order-bill/list-order-bills-simple';
import { ListOrderBillsSimple$Params } from '../fn/order-bill/list-order-bills-simple';
import { pairDevice } from '../fn/order-bill/pair-device';
import { PairDevice$Params } from '../fn/order-bill/pair-device';
import { setOrderBillAsClosed } from '../fn/order-bill/set-order-bill-as-closed';
import { SetOrderBillAsClosed$Params } from '../fn/order-bill/set-order-bill-as-closed';
import { setOrderBillAsPayed } from '../fn/order-bill/set-order-bill-as-payed';
import { SetOrderBillAsPayed$Params } from '../fn/order-bill/set-order-bill-as-payed';
import { setOrderBillAsPayedForTable } from '../fn/order-bill/set-order-bill-as-payed-for-table';
import { SetOrderBillAsPayedForTable$Params } from '../fn/order-bill/set-order-bill-as-payed-for-table';
import { setOrderBillAsPrinted } from '../fn/order-bill/set-order-bill-as-printed';
import { SetOrderBillAsPrinted$Params } from '../fn/order-bill/set-order-bill-as-printed';
import { setOrderBillAsPrintedTrm } from '../fn/order-bill/set-order-bill-as-printed-trm';
import { SetOrderBillAsPrintedTrm$Params } from '../fn/order-bill/set-order-bill-as-printed-trm';
import { setOrderBillAsReadyForClose } from '../fn/order-bill/set-order-bill-as-ready-for-close';
import { SetOrderBillAsReadyForClose$Params } from '../fn/order-bill/set-order-bill-as-ready-for-close';
import { setOrderBillAsReadyForCloseForTable } from '../fn/order-bill/set-order-bill-as-ready-for-close-for-table';
import { SetOrderBillAsReadyForCloseForTable$Params } from '../fn/order-bill/set-order-bill-as-ready-for-close-for-table';
import { setOrderBillAsReadyForPrint } from '../fn/order-bill/set-order-bill-as-ready-for-print';
import { SetOrderBillAsReadyForPrint$Params } from '../fn/order-bill/set-order-bill-as-ready-for-print';
import { splitOrderBill } from '../fn/order-bill/split-order-bill';
import { SplitOrderBill$Params } from '../fn/order-bill/split-order-bill';
import { unPairDevice } from '../fn/order-bill/un-pair-device';
import { UnPairDevice$Params } from '../fn/order-bill/un-pair-device';
import { viewOrder } from '../fn/order-bill/view-order';
import { ViewOrder$Params } from '../fn/order-bill/view-order';
import { viewOrderBill } from '../fn/order-bill/view-order-bill';
import { viewOrderBill_1 } from '../fn/order-bill/view-order-bill-1';
import { ViewOrderBill_1$Params } from '../fn/order-bill/view-order-bill-1';
import { viewOrderBill_2 } from '../fn/order-bill/view-order-bill-2';
import { ViewOrderBill_2$Params } from '../fn/order-bill/view-order-bill-2';
import { ViewOrderBill$Params } from '../fn/order-bill/view-order-bill';
import { viewOrderBillForTable } from '../fn/order-bill/view-order-bill-for-table';
import { ViewOrderBillForTable$Params } from '../fn/order-bill/view-order-bill-for-table';

@Injectable({ providedIn: 'root' })
export class OrderBillService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `viewOrderBill()` */
  static readonly ViewOrderBillPath = '/api/wtr/OrderBill/vieworderbill';

  /**
   * View order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewOrderBill()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrderBill$Response(params?: ViewOrderBill$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewOrderBill(this.http, this.rootUrl, params, context);
  }

  /**
   * View order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewOrderBill$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrderBill(params?: ViewOrderBill$Params, context?: HttpContext): Observable<void> {
    return this.viewOrderBill$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewOrderBillForTable()` */
  static readonly ViewOrderBillForTablePath = '/api/wtr/OrderBill/vieworderbillfortable';

  /**
   * View order for teble.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewOrderBillForTable()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrderBillForTable$Response(params?: ViewOrderBillForTable$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewOrderBillForTable(this.http, this.rootUrl, params, context);
  }

  /**
   * View order for teble.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewOrderBillForTable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrderBillForTable(params?: ViewOrderBillForTable$Params, context?: HttpContext): Observable<void> {
    return this.viewOrderBillForTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listOrderBills()` */
  static readonly ListOrderBillsPath = '/api/wtr/OrderBill/listorderbills';

  /**
   * List orders for waiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOrderBills()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrderBills$Response(params?: ListOrderBills$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listOrderBills(this.http, this.rootUrl, params, context);
  }

  /**
   * List orders for waiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listOrderBills$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrderBills(params?: ListOrderBills$Params, context?: HttpContext): Observable<void> {
    return this.listOrderBills$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listOrderBillsSimple()` */
  static readonly ListOrderBillsSimplePath = '/api/wtr/OrderBill/listorderbillssimple';

  /**
   * List order bills gropped by capacity table.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOrderBillsSimple()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrderBillsSimple$Response(params?: ListOrderBillsSimple$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listOrderBillsSimple(this.http, this.rootUrl, params, context);
  }

  /**
   * List order bills gropped by capacity table.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listOrderBillsSimple$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrderBillsSimple(params?: ListOrderBillsSimple$Params, context?: HttpContext): Observable<void> {
    return this.listOrderBillsSimple$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listOrderBillsForTable()` */
  static readonly ListOrderBillsForTablePath = '/api/wtr/OrderBill/listorderbillsfortable';

  /**
   * List order bills for specific table.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOrderBillsForTable()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrderBillsForTable$Response(params?: ListOrderBillsForTable$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listOrderBillsForTable(this.http, this.rootUrl, params, context);
  }

  /**
   * List order bills for specific table.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listOrderBillsForTable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrderBillsForTable(params?: ListOrderBillsForTable$Params, context?: HttpContext): Observable<void> {
    return this.listOrderBillsForTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listNotPrintedOrderBills()` */
  static readonly ListNotPrintedOrderBillsPath = '/api/wtr/OrderBill/listnotprintedorderbills';

  /**
   * List all order bill sent for print on fiscal printer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listNotPrintedOrderBills()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNotPrintedOrderBills$Response(params?: ListNotPrintedOrderBills$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listNotPrintedOrderBills(this.http, this.rootUrl, params, context);
  }

  /**
   * List all order bill sent for print on fiscal printer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listNotPrintedOrderBills$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNotPrintedOrderBills(params?: ListNotPrintedOrderBills$Params, context?: HttpContext): Observable<void> {
    return this.listNotPrintedOrderBills$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listNotPrintedTrmOrderBills()` */
  static readonly ListNotPrintedTrmOrderBillsPath = '/api/wtr/OrderBill/listnotprintedtrmorderbills';

  /**
   * List all order bill sent for print on termal printer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listNotPrintedTrmOrderBills()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNotPrintedTrmOrderBills$Response(params?: ListNotPrintedTrmOrderBills$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listNotPrintedTrmOrderBills(this.http, this.rootUrl, params, context);
  }

  /**
   * List all order bill sent for print on termal printer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listNotPrintedTrmOrderBills$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNotPrintedTrmOrderBills(params?: ListNotPrintedTrmOrderBills$Params, context?: HttpContext): Observable<void> {
    return this.listNotPrintedTrmOrderBills$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addOrder()` */
  static readonly AddOrderPath = '/api/wtr/OrderBill/addorder';

  /**
   * Add new order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addOrder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addOrder$Response(params?: AddOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * Add new order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addOrder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addOrder(params?: AddOrder$Params, context?: HttpContext): Observable<void> {
    return this.addOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `splitOrderBill()` */
  static readonly SplitOrderBillPath = '/api/wtr/OrderBill/splitorderbill';

  /**
   * Split order on two.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `splitOrderBill()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  splitOrderBill$Response(params?: SplitOrderBill$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return splitOrderBill(this.http, this.rootUrl, params, context);
  }

  /**
   * Split order on two.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `splitOrderBill$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  splitOrderBill(params?: SplitOrderBill$Params, context?: HttpContext): Observable<void> {
    return this.splitOrderBill$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setOrderBillAsPayed()` */
  static readonly SetOrderBillAsPayedPath = '/api/wtr/OrderBill/setorderbillaspayed';

  /**
   * Se order bill as payed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOrderBillAsPayed()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsPayed$Response(params?: SetOrderBillAsPayed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setOrderBillAsPayed(this.http, this.rootUrl, params, context);
  }

  /**
   * Se order bill as payed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setOrderBillAsPayed$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsPayed(params?: SetOrderBillAsPayed$Params, context?: HttpContext): Observable<void> {
    return this.setOrderBillAsPayed$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setOrderBillAsPayedForTable()` */
  static readonly SetOrderBillAsPayedForTablePath = '/api/wtr/OrderBill/setorderbillaspayedfortable';

  /**
   * Se order bill as paid for selected table.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOrderBillAsPayedForTable()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsPayedForTable$Response(params?: SetOrderBillAsPayedForTable$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setOrderBillAsPayedForTable(this.http, this.rootUrl, params, context);
  }

  /**
   * Se order bill as paid for selected table.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setOrderBillAsPayedForTable$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsPayedForTable(params?: SetOrderBillAsPayedForTable$Params, context?: HttpContext): Observable<void> {
    return this.setOrderBillAsPayedForTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setOrderBillAsReadyForPrint()` */
  static readonly SetOrderBillAsReadyForPrintPath = '/api/wtr/OrderBill/setorderbillasreadyforprint';

  /**
   * Set status of the order bill as payed and printed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOrderBillAsReadyForPrint()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsReadyForPrint$Response(params?: SetOrderBillAsReadyForPrint$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setOrderBillAsReadyForPrint(this.http, this.rootUrl, params, context);
  }

  /**
   * Set status of the order bill as payed and printed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setOrderBillAsReadyForPrint$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsReadyForPrint(params?: SetOrderBillAsReadyForPrint$Params, context?: HttpContext): Observable<void> {
    return this.setOrderBillAsReadyForPrint$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addOrderBillDiscount()` */
  static readonly AddOrderBillDiscountPath = '/api/wtr/OrderBill/addorderbilldiscount';

  /**
   * Add discount to specific order bill in percentage or amount.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addOrderBillDiscount()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addOrderBillDiscount$Response(params?: AddOrderBillDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addOrderBillDiscount(this.http, this.rootUrl, params, context);
  }

  /**
   * Add discount to specific order bill in percentage or amount.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addOrderBillDiscount$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addOrderBillDiscount(params?: AddOrderBillDiscount$Params, context?: HttpContext): Observable<void> {
    return this.addOrderBillDiscount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setOrderBillAsReadyForClose()` */
  static readonly SetOrderBillAsReadyForClosePath = '/api/wtr/OrderBill/setorderbillasreadyforclose';

  /**
   * Close the order bill without paying it.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOrderBillAsReadyForClose()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsReadyForClose$Response(params?: SetOrderBillAsReadyForClose$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setOrderBillAsReadyForClose(this.http, this.rootUrl, params, context);
  }

  /**
   * Close the order bill without paying it.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setOrderBillAsReadyForClose$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsReadyForClose(params?: SetOrderBillAsReadyForClose$Params, context?: HttpContext): Observable<void> {
    return this.setOrderBillAsReadyForClose$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setOrderBillAsReadyForCloseForTable()` */
  static readonly SetOrderBillAsReadyForCloseForTablePath = '/api/wtr/OrderBill/setorderbillasreadyforclosefortable';

  /**
   * Set order bill status as slosed for opened bill for that table.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOrderBillAsReadyForCloseForTable()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsReadyForCloseForTable$Response(params?: SetOrderBillAsReadyForCloseForTable$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setOrderBillAsReadyForCloseForTable(this.http, this.rootUrl, params, context);
  }

  /**
   * Set order bill status as slosed for opened bill for that table.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setOrderBillAsReadyForCloseForTable$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsReadyForCloseForTable(params?: SetOrderBillAsReadyForCloseForTable$Params, context?: HttpContext): Observable<void> {
    return this.setOrderBillAsReadyForCloseForTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setOrderBillAsClosed()` */
  static readonly SetOrderBillAsClosedPath = '/api/wtr/OrderBill/setorderbillasclosed';

  /**
   * Set order bill as closed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOrderBillAsClosed()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsClosed$Response(params?: SetOrderBillAsClosed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setOrderBillAsClosed(this.http, this.rootUrl, params, context);
  }

  /**
   * Set order bill as closed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setOrderBillAsClosed$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsClosed(params?: SetOrderBillAsClosed$Params, context?: HttpContext): Observable<void> {
    return this.setOrderBillAsClosed$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteOrderBill()` */
  static readonly DeleteOrderBillPath = '/api/wtr/OrderBill/deleteorderbill';

  /**
   * Delete existing order bill.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOrderBill()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteOrderBill$Response(params?: DeleteOrderBill$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOrderBill(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete existing order bill.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOrderBill$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteOrderBill(params?: DeleteOrderBill$Params, context?: HttpContext): Observable<void> {
    return this.deleteOrderBill$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteOrderBillItem()` */
  static readonly DeleteOrderBillItemPath = '/api/wtr/OrderBill/deleteorderbillitem';

  /**
   * Delete order bill item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOrderBillItem()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteOrderBillItem$Response(params?: DeleteOrderBillItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOrderBillItem(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete order bill item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOrderBillItem$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteOrderBillItem(params?: DeleteOrderBillItem$Params, context?: HttpContext): Observable<void> {
    return this.deleteOrderBillItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setOrderBillAsPrinted()` */
  static readonly SetOrderBillAsPrintedPath = '/api/pos/OrderBill/setorderbillasprinted';

  /**
   * Set status of the order bill as payed and printed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOrderBillAsPrinted()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsPrinted$Response(params?: SetOrderBillAsPrinted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setOrderBillAsPrinted(this.http, this.rootUrl, params, context);
  }

  /**
   * Set status of the order bill as payed and printed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setOrderBillAsPrinted$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsPrinted(params?: SetOrderBillAsPrinted$Params, context?: HttpContext): Observable<void> {
    return this.setOrderBillAsPrinted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setOrderBillAsPrintedTrm()` */
  static readonly SetOrderBillAsPrintedTrmPath = '/api/pos/OrderBill/setorderbillasprintedtrm';

  /**
   * Set status of the order bill as payed and printed for termal printer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOrderBillAsPrintedTrm()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsPrintedTrm$Response(params?: SetOrderBillAsPrintedTrm$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setOrderBillAsPrintedTrm(this.http, this.rootUrl, params, context);
  }

  /**
   * Set status of the order bill as payed and printed for termal printer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setOrderBillAsPrintedTrm$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setOrderBillAsPrintedTrm(params?: SetOrderBillAsPrintedTrm$Params, context?: HttpContext): Observable<void> {
    return this.setOrderBillAsPrintedTrm$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pairDevice()` */
  static readonly PairDevicePath = '/api/pos/OrderBill/pairdevice';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pairDevice()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pairDevice$Response(params?: PairDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pairDevice(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pairDevice$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pairDevice(params?: PairDevice$Params, context?: HttpContext): Observable<void> {
    return this.pairDevice$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `unPairDevice()` */
  static readonly UnPairDevicePath = '/api/pos/OrderBill/unpairdevice';

  /**
   * Un pair the device.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unPairDevice()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  unPairDevice$Response(params?: UnPairDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return unPairDevice(this.http, this.rootUrl, params, context);
  }

  /**
   * Un pair the device.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unPairDevice$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  unPairDevice(params?: UnPairDevice$Params, context?: HttpContext): Observable<void> {
    return this.unPairDevice$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewOrderBill_1()` */
  static readonly ViewOrderBill_1Path = '/api/pos/OrderBill/vieworderbill';

  /**
   * View order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewOrderBill_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrderBill_1$Response(params?: ViewOrderBill_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewOrderBill_1(this.http, this.rootUrl, params, context);
  }

  /**
   * View order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewOrderBill_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrderBill_1(params?: ViewOrderBill_1$Params, context?: HttpContext): Observable<void> {
    return this.viewOrderBill_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewOrder()` */
  static readonly ViewOrderPath = '/api/pos/OrderBill/vieworder';

  /**
   * View order for print.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrder$Response(params?: ViewOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * View order for print.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrder(params?: ViewOrder$Params, context?: HttpContext): Observable<void> {
    return this.viewOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listOrderBills_1()` */
  static readonly ListOrderBills_1Path = '/api/mng/OrderBill/listorderbills';

  /**
   * List orders for waiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOrderBills_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrderBills_1$Response(params?: ListOrderBills_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listOrderBills_1(this.http, this.rootUrl, params, context);
  }

  /**
   * List orders for waiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listOrderBills_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOrderBills_1(params?: ListOrderBills_1$Params, context?: HttpContext): Observable<void> {
    return this.listOrderBills_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewOrderBill_2()` */
  static readonly ViewOrderBill_2Path = '/api/mng/OrderBill/vieworderbill';

  /**
   * View order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewOrderBill_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrderBill_2$Response(params?: ViewOrderBill_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewOrderBill_2(this.http, this.rootUrl, params, context);
  }

  /**
   * View order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewOrderBill_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewOrderBill_2(params?: ViewOrderBill_2$Params, context?: HttpContext): Observable<void> {
    return this.viewOrderBill_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
